import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "c-icon-text-list__inner" }
const _hoisted_3 = { class: "c-icon-text-list__layout" }
const _hoisted_4 = { class: "c-icon-text-list__media" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = {
  key: 0,
  class: "c-icon-text-list__features"
}
const _hoisted_7 = ["src", "alt"]

import { computed } from 'vue';
import utils from '@/utils';
import { RichText, Text as JssText } from '@sitecore-jss/sitecore-jss-vue';
import type { ScItem } from '@/types/sitecore';
import type { SplitLayoutFeatureSectionFields } from '@/types/components/SplitLayoutFeatureSection';
import type { SplitLayoutFeatureSectionFeatureFields } from '@/types/components/SplitLayoutFeatureSection';

interface SplitLayoutFeatureSectionProps {
  fields: SplitLayoutFeatureSectionFields;
  rendering?: any;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SplitLayoutFeatureSection',
  props: {
    fields: {},
    rendering: {}
  },
  setup(__props: any) {

const props = __props;

const fields = computed(() => props.fields);
const rendering = computed(() => props.rendering);
const features = computed(() => fields.value?.features ?? []);
const imageSrc = computed(() => fields.value?.image?.value?.src || '');
const imageAlt = computed(
  () => fields.value?.image?.value?.alt || fields.value?.title?.value || ''
);
const FEATURE_TONES = ['green', 'light-green', 'gold', 'neutral'];

const getTone = (index: number) => FEATURE_TONES[index % FEATURE_TONES.length];
const hasFeatureImage = (feature: ScItem<SplitLayoutFeatureSectionFeatureFields>) =>
  Boolean(feature.fields?.icon?.value?.src);
const getFeatureImageSrc = (feature: ScItem<SplitLayoutFeatureSectionFeatureFields>) =>
  feature.fields?.icon?.value?.src || '';
const getFeatureImageAlt = (feature: ScItem<SplitLayoutFeatureSectionFeatureFields>) =>
  feature.fields?.icon?.value?.alt || feature.name || '';

const rootClass = computed(() => utils.overall.baseComClass(props.fields, 'c-icon-text-list'));
const rootStyle = computed(() => utils.overall?.baseComStyle?.(fields.value) || {});

return (_ctx: any,_cache: any) => {
  const _component_JssRichText = _resolveComponent("JssRichText")!
  const _component_ContentGrid = _resolveComponent("ContentGrid")!

  return (fields.value)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: _normalizeClass(rootClass.value),
        style: _normalizeStyle(rootStyle.value),
        id: rendering.value?.dataSource
      }, [
        _createVNode(_component_ContentGrid, {
          "desktop-default-grid": [2, 20],
          "mobile-default-grid": [1, 14]
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_JssRichText, {
                class: "c-icon-text-list__title",
                field: fields.value?.title,
                tag: "h2"
              }, null, 8, ["field"]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  (imageSrc.value)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "c-icon-text-list__image",
                        src: imageSrc.value,
                        alt: imageAlt.value,
                        loading: "lazy"
                      }, null, 8, _hoisted_5))
                    : _createCommentVNode("", true)
                ]),
                (features.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(features.value, (feature, index) => {
                        return (_openBlock(), _createElementBlock("article", {
                          key: feature.id,
                          class: _normalizeClass(["c-icon-text-list__feature", [
                `c-icon-text-list__feature--${getTone(index)}`,
                { 'c-icon-text-list__feature--has-image': hasFeatureImage(feature) },
              ]])
                        }, [
                          (hasFeatureImage(feature))
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                class: "c-icon-text-list__feature-image",
                                src: getFeatureImageSrc(feature),
                                alt: getFeatureImageAlt(feature),
                                loading: "lazy"
                              }, null, 8, _hoisted_7))
                            : _createCommentVNode("", true),
                          (feature.fields?.description?.value)
                            ? (_openBlock(), _createBlock(_unref(RichText), {
                                key: 1,
                                class: "c-icon-text-list__feature-description",
                                field: feature.fields.description
                              }, null, 8, ["field"]))
                            : _createCommentVNode("", true)
                        ], 2))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        })
      ], 14, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})